type SwitchProps = {
  onValueChange: (value: boolean) => void
  value?: boolean
  disabled?: boolean
}

export function Switch({ onValueChange, value, disabled }: SwitchProps) {
  return (
    <label
      style={{
        position: "relative",
        display: "inline-block",
        width: "60px",
        height: "34px",
      }}
    >
      <input
        type="checkbox"
        checked={value}
        onChange={(e) => onValueChange(e.target.checked)}
        style={{
          opacity: 0,
          width: 0,
          height: 0,
          position: "absolute",
        }}
        disabled={disabled}
      />
      <span
        style={{
          position: "absolute",
          cursor: "pointer",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: value ? "#446CED" : "#CBC7D1",
          transition: ".4s",
          borderRadius: "34px",
          display: "block",
        }}
      >
        <span
          style={{
            position: "absolute",
            height: "26px",
            width: "26px",
            left: value ? "30px" : "4px",
            bottom: "4px",
            backgroundColor: "white",
            transition: ".4s",
            borderRadius: "50%",
            display: "block",
          }}
        />
      </span>
    </label>
  )
}
